import React from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import AddFlashcardGroup from './AddFlashcardGroup';
import { useLanguage } from '../contexts/LanguageContext';
import { generateGroupId } from '../utils/srs';

const AddWordsPage = ({ modules, setModules }) => {
  const { id } = useParams();
  const modIdx = modules.findIndex(m => m.id === parseInt(id, 10));
  const mod = modules[modIdx];
  const navigate = useNavigate();
  const { t, isRTL } = useLanguage();

  const handleAdd = (groupName, wordPairs) => {
    const updatedModules = modules.map((module, idx) => 
      idx === modIdx
        ? {
            ...module,
            word_groups: [...(module.word_groups || []), { 
              id: generateGroupId(), // Add unique ID to the new word group
              name: groupName, 
              words: wordPairs 
            }]
          }
        : module
    );
    setModules(updatedModules);
    navigate(`/module/${mod.id}`);
  };

  if (!mod) {
    return (
      <div className="card" dir={isRTL ? 'rtl' : 'ltr'} style={{ textAlign: 'center', padding: '2rem' }}>
        <h2>{t('moduleNotFound')}</h2>
        <p>{t('moduleNotFoundMessage')}</p>
        <Link to="/" className="btn btn-primary">{t('backToModules')}</Link>
      </div>
    );
  }

  return (
    <div className="card" dir={isRTL ? 'rtl' : 'ltr'}>
              <h2>{t('addWords')} {mod.from_lang} → {mod.to_lang}</h2>
        <AddFlashcardGroup from={mod.from_lang} to={mod.to_lang} onAdd={handleAdd} onCancel={() => navigate(`/module/${mod.id}`)} />
    </div>
  );
};

export default AddWordsPage; 